import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { CURRENT_LANGUAGE } from './constants/global';
import { getI18n, tryLocalI18n } from './service/pear';

i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: CURRENT_LANGUAGE, // 初始请求的语言类型
    supportedLngs: ['zh', 'en', 'ru'], // 允许请求的语言类型
    backend: {
      // loadPath: '/locales/{{lng}}.json?v=1675158077564',
      loadPath: '{{lng}}',
      ajax(url, options, callback, data) {
        getI18n(url)
          .then((res) => {
            const content = res ?? null;
            callback(JSON.stringify(content), { status: content ? 200 : 500 });
          })
          .catch((err) => {
            console.error('i18n load error: ', err);

            // 尝试加载本地多语言文件，以防万一
            tryLocalI18n(url)
              .then((fetchRes) => {
                console.log('加载本地多语言');
                const content = fetchRes ?? null;
                callback(JSON.stringify(content), { status: content ? 200 : 500 });
              })
              .catch((fetchErr) => {
                console.error('i18n local load error: ', err);
                callback(null, { status: 500 });
              });
          });
      },
    },
    // debug: true,
    fallbackLng: CURRENT_LANGUAGE,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
